import Modal from "react-bootstrap/Modal";
import React, {useState} from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import {useTranslation} from "react-i18next";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import * as AssetsService from "../../api/AssetsService"

export default function MyCardsDeckEditAddOwnBackground(props) {
    const {t} = useTranslation('translation', {keyPrefix: 'myCardsDeckEdit'});
    const [fileUploadError, setFileUploadError] = useState()
    const [imgFile, setImgFile] = useState()
    const [imgHeight, setImgHeight] = useState(0)
    const [imgWidth, setImgWidth] = useState(0)
    const [paddingLeft, setPaddingLeft] = useState(10)
    const [paddingRight, setPaddingRight] = useState(10)
    const [paddingTop, setPaddingTop] = useState(10)
    const [paddingBottom, setPaddingBottom] = useState(10)
    const [fontColor, setFontColor] = useState("#000000")

    const [saveButtonDisabled, setSaveButtonDisabled] = useState(false)

    const [showPrivateNotes, setShowPrivateNotes] = useState(true)


    function handleFileSelected(event) {
        const file = event.target.files[0]
        if (!file) {
            return
        }

        if (file?.size > 2050000) {
            setFileUploadError(t('maxFileSize'))
            setImgFile(null)
            return
        }


        let fileUrl = URL.createObjectURL(file)
        let img = new Image();
        let _imgWidth = 0
        let _imgHeight = 0
        let scaleDownRatio = 1
        img.onload = function () {
            _imgWidth = this.width
            _imgHeight = this.height
            if (_imgWidth >= _imgHeight) {
                scaleDownRatio = _imgWidth / 400
            } else {
                scaleDownRatio = _imgHeight / 600
            }
            console.log(scaleDownRatio)

            setImgWidth(Math.floor(_imgWidth / scaleDownRatio))
            setImgHeight(Math.floor(_imgHeight / scaleDownRatio))

            URL.revokeObjectURL(fileUrl);
        };
        img.src = fileUrl;
        setImgFile(file)
        setFileUploadError(null)
    }

    function handleWidthChange(event) {
        setImgWidth(event.target.value)
    }

    function handleHeightChange(event) {
        setImgHeight(event.target.value)
    }

    function handleLeftPaddingChange(event) {
        setPaddingLeft(event.target.value)
    }

    function handleRightPaddingChange(event) {
        setPaddingRight(event.target.value)
    }

    function handleTopPaddingChange(event) {
        setPaddingTop(event.target.value)
    }

    function handleBottomPaddingChange(event) {
        setPaddingBottom(event.target.value)
    }

    function handleColorChange(event) {
        setFontColor(event.target.value)
    }

    function save() {
        setSaveButtonDisabled(true)
        AssetsService.createNewBackground(
            imgHeight,
            imgWidth,
            paddingTop,
            paddingLeft,
            paddingRight,
            paddingBottom,
            fontColor,
            (res) => {
                const bkgId = res.id
                AssetsService.getCustomBackgroundPresignedUploadRequest(
                    bkgId,
                    imgFile.name.split(".").slice(-1)[0],
                    (awsRequest) => {
                        const s3FileUrl = awsRequest.data.url + awsRequest.data.fields.key
                        const formData = new FormData();

                        for (const key in awsRequest.data.fields) {
                            formData.append(key, awsRequest.data.fields[key]);
                        }

                        formData.append("file", imgFile)
                        fetch(awsRequest.url, {
                            method: "POST",
                            body: formData
                        }).then(() => {
                                AssetsService.updateBackgroundImgUrl(
                                    bkgId,
                                    s3FileUrl,
                                    () => {
                                        props.fetchAvailableStyles()
                                        props.onClose()
                                    },
                                    () => {setFileUploadError("Failed to update style")}
                                )
                            }
                        )
                            .catch((e) => {setFileUploadError("Failed to update style")})
                    },
                    () => {setFileUploadError("failed to upload file")}
                )
            },
            () => {setFileUploadError("Failed to create style")}
        )
    }

    return <Modal
        size="lg"
        show={props.show}
        dialogClassName={imgFile ? cabinetStyle.uploadCardBackgroundmodal : cabinetStyle.uploadCardBackgroundmodalSmall}
        contentClassName={imgFile ? cabinetStyle.uploadCardBackgroundmodal : cabinetStyle.uploadCardBackgroundmodalSmall}
    >
        <div style={{
            margin: "12px"
        }}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between"
                }}
            >
                <label htmlFor="upload-img"
                       className={cabinetStyle.uploadPhotoButton}>{t('uploadFile')}</label>
                <input
                    type="file"
                    accept="image/jpg, image/png, image/jpeg"
                    id={"upload-img"}
                    name="Photo"
                    onChange={handleFileSelected}
                    style={{display: "none"}}
                />
                {imgFile && <button disabled={saveButtonDisabled} className={cabinetStyle.uploadPhotoButton}
                                    onClick={save}>{t('saveButton')}</button>}

                <button className={cabinetStyle.uploadPhotoButton} style={{backgroundColor: "red"}} onClick={props.onClose}>{t('cancelButton')}</button>
            </div>
            <div style={{
                height: imgFile ? (150 + parseInt(imgHeight)) + "px" : "60px",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>
                {fileUploadError && <span>{fileUploadError}</span>}
                {imgFile && <div style={{display: "flex", justifyContent: "space-evenly", width: "40%"}}>
                    <label htmlFor="height-input">Висота:</label>
                    <input id="height-input" type="number" value={imgHeight} style={{height: "24px", width: "60px"}}
                           onChange={handleHeightChange}/>
                    <label htmlFor="width-input">Ширина:</label>
                    <input id="width-input" type="number" value={imgWidth} style={{height: "24px", width: "60px"}}
                           onChange={handleWidthChange}/>
                </div>}
                {imgFile && <div
                    style={{border: "0.5px solid black", width: "100%", margin: "6px", marginBottom: "12px"}}></div>}
                {imgFile && <div style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    gap:"24px"
                }}>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
                        {/*left col*/}
                        <div style={{height: "48px"}}></div>
                        <div style={{display: "flex", justifyContent: "center", flexDirection: "column"}}>
                            <label htmlFor="left-padding-input">Відступ:</label>
                            <input id="left-padding-input" type="number" value={paddingLeft}
                                   style={{height: "24px", width: "60px"}} onChange={handleLeftPaddingChange}/>
                        </div>
                        <div></div>

                    </div>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                        {/*middle col*/}
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <label htmlFor="top-padding-input">Відступ:</label>
                            <input id="top-padding-input" type="number" value={paddingTop}
                                   style={{height: "24px", width: "60px"}} onChange={handleTopPaddingChange}/>
                        </div>

                        <div style={{
                            margin: "6px",
                            backgroundImage: "url(" + URL.createObjectURL(imgFile) + ")",
                            height: imgHeight + "px",
                            width: imgWidth + "px",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            paddingTop: paddingTop + "px",
                            paddingBottom: paddingBottom + "px",
                            paddingLeft: paddingLeft + "px",
                            paddingRight: paddingRight + "px",
                            borderRadius: "6px",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            border: "0.5px solid black",
                            color: fontColor,
                        }}>
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                fontWeight: "bolder",
                                fontSize: "36px",
                                fontFamily: 'Tenor Sans'
                            }}>1
                            </div>
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                fontWeight: "bold",
                                fontSize: "24px",
                                fontFamily: 'Tenor Sans'
                            }}>
                                {"Lūsum"}
                            </div>
                            <div style={{
                                fontWeight: "normal",
                                fontSize: "20px",
                                overflow: "auto",
                                minHeight: "120px",
                            }}>
                                {"Hominis iter, inter ortum et occasum, simile est lūdō: incipit sine scientiā, pergit cum spēs et timoribus, mutat faciem, sed semper manet scaena. Rīdēs? Flēs? Omnia sunt pars lūdi. Sapientia est nōn timēre lūdere, sed agere cum corde, quasi verum sit."}
                            </div>
                            <br/>
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontWeight: "bold",
                                fontSize: "24px",
                                gap: "12px",
                                fontFamily: 'Tenor Sans'
                            }}>
                                {'Notae privātae'}
                                {showPrivateNotes ?
                                    <VisibilityOffIcon
                                        style={{cursor: "pointer"}}
                                        onClick={() => setShowPrivateNotes(false)}
                                    />
                                    :
                                    <VisibilityIcon
                                        style={{cursor: "pointer"}}
                                        onClick={() => setShowPrivateNotes(true)}
                                    />}

                            </div>

                            <div
                                style={{
                                    fontWeight: "normal",
                                    fontSize: "20px",
                                    overflow: "auto",
                                    minHeight: "120px",
                                    display: showPrivateNotes ? "block" : "none"
                                }}
                            >{"Vincere potest sōlum quī lūdit; sed lūdus ipse est praemium. " +
                                "Vīta est scaena, et omnēs sumus lūdentēs. " +
                                "Sapiēns nōn quaerit tantum palmam, sed intellegit pulchritūdinem mōmentī. " +
                                "Nōn semper clārē videntur ratiōnēs aut prēmia, " +
                                "sed lūdere ipse — iam est actus vītae plenissimae. " +
                                "Lūdus nūtri animum, dētegit vērērum tē, " +
                                "et in mediō incertō, parit fiduciam. " +
                                "Gaudium nāscitur nōn post victoriam, sed in risū, in errōre, in conātū. " +
                                "Lūdere est vīvī — ex corde, ex spē, ex vērā praesentia. " +
                                "Nōlī timēre incipere: " +
                                "nam etiam lūdus imperfectus est melior quam silentium spectātōris."}</div>


                        </div>
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <label htmlFor="bottom-padding-input">Відступ:</label>
                            <input id="bottom-padding-input" type="number" value={paddingBottom}
                                   style={{height: "24px", width: "60px"}} onChange={handleBottomPaddingChange}/>
                        </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                        {/*right col*/}
                        <div style={{display: "flex", justifyContent: "space-between", flexDirection: "column", height: "100%"}}>
                            <div style={{height: "48px", display:"flex", flexDirection:"column", marginTop: "24px"}}>
                                <label htmlFor="color-input">Колір шрифту:</label>
                                <input id="color-input" type="color" value={fontColor} onChange={handleColorChange}/>
                            </div>
                            <div style={{display: "flex", flexDirection:"column"}}>
                                <label htmlFor="right-padding-input">Відступ:</label>
                                <input id="right-padding-input" type="number" value={paddingRight}
                                       style={{height: "24px", width: "60px"}} onChange={handleRightPaddingChange}/>
                            </div>
                            <div></div>
                        </div>
                    </div>

                </div>}
            </div>

        </div>

    </Modal>
}